<app-form-dialog-shell
  [icon]="isEditing ? 'edit' : 'report_problem'"
  [heading]="isEditing ? 'Seguimiento de incidencia' : 'Reportar incidencia'"
  [saving]="saving()"
  [saveLabel]="isEditing ? 'Guardar cambios' : 'Reportar'"
  [saveIcon]="isEditing ? 'save' : 'send'"
  formId="incident-form"
  (cancelled)="close()"
  >
<form id="incident-form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="form-grid">

    <!-- Tipo -->
    <mat-form-field appearance="outline">
      <mat-label>Tipo de incidencia</mat-label>
      <mat-select formControlName="type">
        @for (t of types; track t) {
          <mat-option [value]="t">{{ t }}</mat-option>
        }
      </mat-select>
      @if (isEditing) {<mat-hint>El tipo no se puede cambiar</mat-hint>}
    </mat-form-field>

    <!-- Hospital y médico -->
    <app-auto-select label="Hospital" formControlName="place" [options]="hospitalOptions" [labelFn]="placeLabel"></app-auto-select>
    <app-auto-select label="Médico" formControlName="doctor" [options]="doctorOptions" [labelFn]="doctorLabel" [allowEmpty]="true" emptyLabel="— Sin médico —"></app-auto-select>

    <!-- Servicio -->
    <!-- CIR (servicio hospitalario): acota la lista de insumos -->
    <app-auto-select label="CIR (servicio)" formControlName="hospitalService" [options]="services" [labelFn]="serviceLabel" [allowEmpty]="true" emptyLabel="— Sin CIR —"></app-auto-select>

    @if (isInsumo) {
      <!-- Insumos: folio + motivo -->
      <app-auto-select label="Folio/Remisión (del hospital)" formControlName="interventionFolio" [options]="folioOptions" [labelFn]="folioLabel" [allowEmpty]="true" emptyLabel="— Sin folio —"></app-auto-select>

      <mat-form-field appearance="outline">
        <mat-label>Razón de la incidencia</mat-label>
        <mat-select formControlName="reason">
          @for (r of reasons; track r) {
            <mat-option [value]="r">{{ r }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (form.getRawValue().reason === 'CALIDAD') {
        <p class="full-col reason-def"><mat-icon>info</mat-icon>
          <span>No cumple con alguna o varias de las siguientes características como: calidad, seguridad, capacidad, eficacia, facilidad de uso o rendimiento para el que fue destinado.</span></p>
      }
    } @else {
      <!-- Equipo / Instrumental: del catálogo. Accesorio: texto libre. -->
      @if (usesCatalog) {
        <app-auto-select [label]="(currentType === 'EQUIPO' ? 'Equipo' : 'Instrumental') + (form.getRawValue().place ? ' (del hospital)' : ' (elige el hospital)')" formControlName="catalogItem" [options]="pieceOptions" [labelFn]="pieceLabel"></app-auto-select>
        @if (isOtherEquipment) {
          <mat-form-field appearance="outline">
            <mat-label>¿Qué equipo?</mat-label>
            <input matInput formControlName="otherEquipment" placeholder="Ej. MONITOR, BOMBA DE INFUSIÓN…" />
          </mat-form-field>
        }
      } @else {
        <mat-form-field appearance="outline">
          <mat-label>Accesorio</mat-label>
          <input matInput formControlName="equipmentName" placeholder="Nombre del accesorio" />
        </mat-form-field>
      }

      <mat-form-field appearance="outline">
        <mat-label>Número de serie</mat-label>
        <input matInput formControlName="serialNumber" />
        <mat-icon matPrefix>qr_code_2</mat-icon>
      </mat-form-field>

      @if (hasPriority) {
        <mat-form-field appearance="outline">
          <mat-label>Clasificación de prioridad</mat-label>
          <mat-select formControlName="priority">
            <mat-option value="ALTA">Alta — no funcional, compromete procedimientos</mat-option>
            <mat-option value="MEDIA">Media — funcional con falla que puede progresar</mat-option>
            <mat-option value="BAJA">Baja — falla menor / estética</mat-option>
          </mat-select>
        </mat-form-field>
      }

      <div class="toggle-row">
        <mat-slide-toggle formControlName="needsReplacement" color="primary">
          ¿Necesitas remplazo?
        </mat-slide-toggle>
      </div>
    }

    @if (isInsumo || pieces().length) {
      <!-- Insumos no conformes: pasan a "No conforme" al reportar -->
      <div class="full-col nc">
        <div class="nc__head">
          <mat-icon>inventory_2</mat-icon>
          <b>Insumos de la incidencia</b>
          <span>Al reportar, estas piezas cambian a <b>No conforme</b>.</span>
        </div>

        @if (!isEditing) {
          <div class="nc__source" role="radiogroup" aria-label="De dónde se agrega">
            <button type="button" [class.on]="pieceSource === 'FOLIO'" (click)="pieceSource = 'FOLIO'">
              <mat-icon>receipt_long</mat-icon> Del folio / remisión</button>
            <button type="button" [class.on]="pieceSource === 'LOCKER'" (click)="pieceSource = 'LOCKER'">
              <mat-icon>search</mat-icon> Del locker del hospital</button>
          </div>

          @if (pieceSource === 'FOLIO') {
            @if (!form.getRawValue().interventionFolio) {
              <p class="nc__hint">Elige arriba el folio o la remisión para ver sus insumos.</p>
            } @else {
              <div class="nc__add">
                <app-auto-select class="nc__pick" [label]="'Pieza del ' + form.getRawValue().interventionFolio + ' (' + folioPieceOptions.length + ')'"
                  [ngModel]="folioPick" (ngModelChange)="folioPick = $event" [ngModelOptions]="{standalone: true}"
                  [options]="folioPieceOptions" [labelFn]="folioPieceLabel" [allowEmpty]="true" emptyLabel="— Elige la pieza —"></app-auto-select>
                <button mat-flat-button color="primary" type="button" [disabled]="!folioPick" (click)="addFolioPiece()">
                  <mat-icon>add</mat-icon> Agregar</button>
              </div>
              @if (!folioPieceOptions.length) { <p class="nc__hint">Este folio / remisión no tiene más piezas para agregar.</p> }
            }
          } @else {
            @if (!form.getRawValue().place) {
              <p class="nc__hint">Elige el hospital para buscar en sus lockers.</p>
            } @else {
              <mat-form-field appearance="outline" class="nc__search" subscriptSizing="dynamic">
                <mat-label>Buscar por lote, RFID o código</mat-label>
                <input matInput [value]="lockerQuery" (input)="onLockerQuery($any($event.target).value)" autocomplete="off">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
              @if (lockerSearching()) { <p class="nc__hint">Buscando…</p> }
              @else if (lockerQuery.trim().length >= 2 && !lockerResults().length) { <p class="nc__hint">Sin piezas disponibles con ese dato.</p> }
              @if (lockerResults().length) {
                <div class="nc__results">
                  @for (r of lockerResults(); track r.stock) {
                    <button type="button" (click)="addLockerPiece(r)">
                      <b>{{ r.code }}</b> <span>Lote {{ r.batch || 'S/L' }}</span> <span>{{ r.tagRfid || 'sin RFID' }}</span>
                      <small>{{ r.description }}</small><mat-icon>add_circle</mat-icon>
                    </button>
                  }
                </div>
              }
            }
          }
        }

        @if (pieces().length) {
          <table class="nc__table">
            <thead><tr><th>Código</th><th>Descripción</th><th>Lote</th><th>RFID</th><th>Origen</th>@if (!isEditing) {<th></th>}</tr></thead>
            <tbody>
              @for (p of pieces(); track p.stock; let i = $index) {
                <tr>
                  <td><b>{{ p.code }}</b></td><td>{{ p.description }}</td><td>{{ p.batch || 'S/L' }}</td>
                  <td><code>{{ p.tagRfid || '—' }}</code></td>
                  <td>{{ p.origin || (p.source === 'FOLIO' ? 'Folio / remisión' : 'Locker') }}</td>
                  @if (!isEditing) {
                    <td><button mat-icon-button type="button" color="warn" (click)="removePiece(i)" aria-label="Quitar"><mat-icon>close</mat-icon></button></td>
                  }
                </tr>
              }
            </tbody>
          </table>
          <p class="nc__count">{{ pieces().length }} pieza(s){{ isEditing ? ' marcadas como No conforme' : '' }}</p>
        } @else if (!isEditing) {
          <p class="nc__hint">Sin insumos agregados.</p>
        } @else {
          <!-- Registros anteriores a la tabla: lo que se capturó entonces. -->
          <p class="nc__hint">{{ [data.incident?.equipmentName, data.incident?.batch ? 'Lote ' + data.incident?.batch : '', data.incident?.tagRfid].filter(Boolean).join(' · ') || 'Sin insumos registrados.' }}</p>
        }
      </div>
    }

    <!-- Descripción -->
    <mat-form-field appearance="outline" class="full-col">
      <mat-label>Explícanos a detalle qué pasó</mat-label>
      <textarea matInput formControlName="description" rows="4"></textarea>
      @if (fieldError('description')) {<mat-error>La descripción es requerida</mat-error>}
    </mat-form-field>

    @if (isEditing && data.incident?.qualityClass) {
      <p class="full-col quality-hint">
        <mat-icon>{{ data.incident!.qualityClass === 'CALIDAD' ? 'report' : 'check_circle' }}</mat-icon>
        Clasificación: <b>{{ data.incident!.qualityClass }}</b>
        <span>{{ data.incident!.qualitySource === 'MANUAL' ? '· corregida por ' + (data.incident!.qualityBy || 'una persona') : '· sugerida por el modelo (' + ((data.incident!.qualityScore || 0) * 100).toFixed(0) + '%)' }}</span>
      </p>
    } @else if (!isEditing && suggestion()?.qualityClass) {
      <p class="full-col quality-hint" [class.quality-hint--q]="suggestion()!.qualityClass === 'CALIDAD'">
        <mat-icon>auto_awesome</mat-icon>
        Clasificación sugerida: <b>{{ suggestion()!.qualityClass }}</b>
        <span>· {{ ((suggestion()!.qualityScore || 0) * 100).toFixed(0) }}% de confianza. Se guarda al reportar; mesa de control puede corregirla.</span>
      </p>
    }

    <!-- Fotos de evidencia -->
    <div class="full-col photos">
      <div class="photos__head">
        <span class="photos__title">Fotos de evidencia</span>
        @if (!isEditing) {
          <span class="photos__hint">{{ photos().length }} de {{ maxPhotos }} · imágenes de hasta 8 MB</span>
        }
      </div>
      <div class="photos__grid">
        @if (isEditing) {
          @for (p of savedPhotos(); track p.key) {
            @if (p.url) {
              <a class="photo" [href]="p.url" target="_blank" rel="noopener" aria-label="Ver foto"><img [src]="p.url" alt="Evidencia"></a>
            } @else {
              <span class="photo photo--empty"><mat-icon>image</mat-icon></span>
            }
          } @empty {
            <span class="photos__hint">Sin fotos de evidencia.</span>
          }
        } @else {
          @for (p of photos(); track p.url; let i = $index) {
            <span class="photo">
              <img [src]="p.url" alt="Evidencia">
              <button type="button" class="photo__remove" (click)="removePhoto(i)" aria-label="Quitar foto"><mat-icon>close</mat-icon></button>
            </span>
          }
          @if (photos().length < maxPhotos) {
            <label class="photo photo--add">
              <mat-icon>add_a_photo</mat-icon><span>Agregar</span>
              <input type="file" accept="image/*" capture="environment" multiple hidden (change)="addPhotos($event)">
            </label>
          }
        }
      </div>
    </div>

    @if (isEditing) {
      <!-- Seguimiento -->
      <mat-form-field appearance="outline" class="full-col">
        <mat-label>Resolución</mat-label>
        <textarea matInput formControlName="resolution" rows="2"
        placeholder="Cómo se atendió la incidencia"></textarea>
      </mat-form-field>
    }

  </div>
</form>
</app-form-dialog-shell>
